export const nativeContent = {
  humanPublishNote:
    'El motor solo redacta. Una persona revisa, edita y publica con su propia cuenta.',
  channels: {
    reddit: {
      description: 'Una respuesta útil para un hilo existente, o un post propio, listo para publicar.',
    },
    x: { description: 'Variantes de post o un hilo, con réplicas para los primeros minutos.' },
    linkedin: { description: 'Un post profesional en tu voz.' },
    instagram: { description: 'Captions pensados para lo visual.' },
    quora: { description: 'Respuestas que posicionan tu expertise.' },
    medium: { description: 'Artículos largos para construir autoridad.' },
  },
  formats: {
    contribution: 'Contribución (respuesta)',
    post: 'Post',
    xPost: 'Post',
    thread: 'Hilo',
  },
  status: {
    pending: 'Pendiente',
    generating: 'Generando',
    completed: 'Completado',
    failed: 'Falló',
  },
  sourceType: {
    plan_item: 'Plan de contenidos',
    scratch: 'Desde cero',
    knowledge: 'Reunión o notas',
  },
  state: {
    draft: 'Borrador',
    approved: 'Aprobado',
    scheduled: 'Programado',
    scheduleFailed: 'Falló la publicación',
    published: 'Publicado',
    scheduledTooltip: 'Se publica el {{datetime}}',
    scheduleFailedTooltip: 'La publicación programada falló: {{reason}}',
    scheduleFailedTooltipNoReason:
      'La publicación programada falló. Abrí la pieza para ver el detalle.',
  },
  qa: {
    unavailable: 'Sin chequeo',
    offVoice: 'Fuera de voz',
    showReport: 'Ver control de calidad',
    hideReport: 'Ocultar control de calidad',
    failedRules: 'Chequeos fallados',
    suggestedFixes: 'Arreglos sugeridos',
    verdict: {
      pass: 'Calidad OK',
      needsChanges: 'Con observaciones',
      fail: 'Con problemas',
    },
    ruleFallback: 'Chequeo de estilo',
    rules: {
      'rd-answers-thread': 'Responde directamente lo que pide el hilo',
      'rd-grounded': 'Todos los datos son reales (nada inventado)',
      'rd-brand-natural': 'La marca se menciona como máximo una vez, de forma natural',
      'rd-no-features': 'Sin lista de características ni tono publicitario',
      'rd-no-cta': 'Sin llamados a la acción ni links que no fueron provistos',
      'rd-peer-tone': 'Suena a un par del subreddit, no a una empresa',
      'rd-length': 'Extensión entre 120 y 300 palabras',
      'rd-no-disclosure': 'No aclara que trabaja en la empresa',
      'x-le-280': 'Cada posteo/reply tiene 280 caracteres o menos',
      'x-hook-delivers': 'El hook inicial cumple lo que promete',
      'x-grounded': 'Todos los datos son reales (nada inventado)',
      'x-no-hashtags': 'Sin hashtags',
      'x-no-link-in-body': 'Sin links dentro del posteo (solo en un reply aparte)',
      'x-reply-angles': 'Incluye 2 a 3 replies con ángulos útiles',
      'x-thread-shape': 'El hilo tiene entre 5 y 7 tweets y cierra de forma concreta',
      'x-voice': 'El tono es consistente con la voz de marca',
      'li-grounded': 'Todos los datos son reales (nada inventado)',
      'li-hook-strong': 'El hook inicial es fuerte y el post lo cumple',
      'li-stance-developed': 'Desarrolla una postura propia, no es un resumen',
      'li-no-emdash': 'Evitá el guión largo (—)',
      'li-no-x-sino-y': 'Evitá la fórmula "no es X, sino Y"',
      'li-no-rule-of-three': 'Evitá tríadas retóricas ("X, Y y Z")',
      'li-no-cta-generic': 'Sin pregunta de cierre genérica: el cierre es un paso concreto',
      'li-no-overformat': 'Sin exceso de negritas, emojis o bullets',
      'li-length': 'Extensión entre 600 y 1400 caracteres',
      'li-paragraphs': 'Párrafos cortos, de 1 a 2 líneas',
      'li-voice-person': 'Escrito en primera persona (cuando se eligió voz personal)',
    },
  },
  wizard: {
    back: 'Atrás',
    continue: 'Continuar',
    generate: 'Generar borrador',
    viewList: 'Ver todo el contenido',
    channelStep: {
      title: '¿Qué querés crear?',
      subtitle: 'Elegí un canal. El motor redacta contenido nativo para cada uno.',
      comingSoon: 'Próximamente',
      humanBadge: 'La publica una persona — el motor solo redacta',
      publishesFromReferentBadge: 'Se publica desde Referent con tu cuenta',
    },
    sourceStep: {
      title: '¿De dónde sale el material?',
      subtitle: 'El motor pone el resto: voz de marca y conocimiento.',
      scratch: {
        title: 'Desde cero',
        description: 'Vos traés la idea cruda y el dato real.',
      },
      knowledge: {
        title: 'Desde una reunión o tus notas',
        description: 'Pegá notas de una reunión, un brief o cualquier material en crudo. El motor lo usa como base.',
      },
      notesLabel: 'Pegá tu material',
      notesPlaceholder: 'Notas de reunión, datos clave, citas…',
      notesHelper: 'Mínimo {{min}} caracteres — {{count}} hasta ahora.',
      kbLabel: 'Anclar en base de conocimiento (opcional, hasta {{max}})',
      kbSearchPlaceholder: 'Buscar en la base de conocimiento…',
      kbNoResults: 'Sin resultados.',
    },
    formStep: {
      title: 'Crear para {{channel}}',
      subtitle: 'Dale al motor lo que solo vos tenés. El resto lo pone él.',
      brandVoiceLabel: 'Voz de marca',
    },
    inference: {
      title: 'Lo que el motor infiere',
      brandVoice: 'Voz de marca',
      noBrandVoice: 'Sin voz específica',
      kbSources: 'Fuentes de conocimiento',
      kbEmpty: 'Ninguna seleccionada.',
      planRow: 'Fila del plan',
      keyword: 'Keyword',
      planTitle: 'Título',
      approach: 'Enfoque',
      footer: 'Vos ponés lo irreemplazable. El motor pone el resto.',
    },
    generating: {
      title: 'Generando tu contenido',
      hint: 'Esto toma unos segundos — no cierres la pantalla.',
      drafting: 'Redactando…',
      qa: 'Pasando el control de calidad…',
    },
  },
  forms: {
    reddit: {
      subreddit: 'Subreddit',
      subredditPlaceholder: 'r/subreddit',
      topic: 'Tema',
      differentiator: 'Qué hace que este post valga la pena (el ángulo que solo vos tenés)',
      differentiatorHelper: 'Algo verificable — un caso real, un número, una lección aprendida.',
      titleOptional: 'Título (opcional)',
      threadUrl: 'URL del hilo',
      evidence: 'El dato/caso real que ancla tu respuesta',
      evidenceHelper:
        'Algo verificable: un número, un caso, una fecha — lo que la IA no puede inventar.',
      stance: 'Tu postura en una frase',
      subredditContext: 'Notas del sub (opcional)',
    },
    x: {
      realDatum: 'El resultado/plazo/error REAL',
      realDatumHelper: 'El material de hook irreemplazable — lo que la IA no puede inventar.',
      hookSeed: 'Tu propio hook (opcional)',
      linkUrl: 'Link (opcional)',
      linkUrlHelper: 'Va en el primer reply, nunca en el cuerpo del tweet.',
      voice: 'Voz',
      voicePersonal: 'Personal',
      voiceBrand: 'Marca',
    },
    linkedin: {
      stance: 'Tu postura',
      realDatum: 'El dato/anécdota verificable',
      realDatumHelper: 'Algo chequeable — un número, nombre o fecha real que la IA no puede inventar.',
      hookType: 'Tipo de hook',
      hookTypeContrarian: 'Contrarian',
      hookTypeContrarianHint: 'Desafía una creencia común de tu industria.',
      hookTypeStat: 'Dato',
      hookTypeStatHint: 'Abre con un número o dato que sorprenda.',
      hookTypeStory: 'Historia',
      hookTypeStoryHint: 'Arranca con una anécdota o escena real.',
      hookTypeDirect: 'Directo',
      hookTypeDirectHint: 'Va al grano, sin vueltas ni rodeos.',
      closingNextStep: 'Cierre / próximo paso (opcional)',
      closingNextStepHelper: 'Un próximo paso concreto. Si lo dejás vacío, el motor propone uno — nunca una pregunta de CTA genérica.',
      voice: 'Voz',
      voicePersonal: 'Marca personal',
      voiceBrand: 'Página de empresa',
    },
    errors: {
      required: 'Completá este campo.',
      url: 'Ingresá una URL válida (https://…).',
      tooShort: 'Necesitás escribir un poco más.',
      tooLong: 'Te pasaste del largo permitido.',
      selectOption: 'Elegí una opción.',
    },
  },
  personalVoice: {
    voiceLabel: 'Voz',
    myVoice: 'Tus voces personales',
    back: 'Volver al motor',
    hintLoadFailed: 'No pudimos cargar tus voces personales.',
    listTitle: 'Tus voces personales',
    listSubtitle: 'Voces con nombre que el motor usa cuando firmás una pieza como personal.',
    newVoice: 'Nueva voz',
    editVoice: 'Editar voz',
    nameLabel: 'Nombre de la voz',
    namePlaceholder: 'Ej.: Mi voz de LinkedIn',
    description:
      'Pegá tus 3-5 mejores posts reales: el motor los usa como ejemplos para escribir con tu tono, ritmo y vocabulario.',
    channelsLabel: 'Canales',
    channelsHelper: 'Para qué canales aplica esta voz. Cada canal usa el registro que le corresponde.',
    postsLabel: 'Tus mejores posts',
    postLabel: 'Post {{number}}',
    postPlaceholder: 'Pegá acá un post tuyo real, tal cual lo publicaste…',
    addPost: 'Agregar otro post',
    removePost: 'Quitar este post',
    positioningLabel: 'Posicionamiento (opcional)',
    positioningPlaceholder: 'Ej.: Fundador técnico que escribe sobre producto B2B sin humo',
    dosLabel: 'Hacer (opcional, una regla por línea)',
    dontsLabel: 'Evitar (opcional, una regla por línea)',
    save: 'Guardar voz',
    cancel: 'Cancelar',
    columnName: 'Nombre',
    columnChannels: 'Canales',
    columnPosts: 'Posts',
    columnActions: 'Acciones',
    empty: {
      title: 'Todavía no tenés voces personales',
      description:
        'Creá una voz con tus posts reales para que el motor escriba contenido de LinkedIn o X con tu propio tono.',
      cta: 'Creá tu primera voz',
    },
    deleteConfirmTitle: '¿Borrar esta voz?',
    deleteConfirm: 'Esta acción no se puede deshacer.',
    deleteAction: 'Borrar',
    selectLabel: 'Voz personal',
    selectNone: 'Sin voz personal',
    selectManage: 'Gestionar voces',
    selectEmptyForChannel: 'No tenés voces para este canal.',
    toast: {
      created: 'Voz personal creada.',
      updated: 'Voz personal actualizada.',
      deleted: 'Voz personal borrada.',
      saveFailed: 'No se pudo guardar la voz personal.',
      deleteFailed: 'No se pudo borrar la voz.',
    },
    errors: {
      postTooShort: 'Cada post necesita al menos 50 caracteres.',
      postTooLong: 'Cada post puede tener hasta 3000 caracteres.',
      listItemTooLong: 'Cada regla puede tener hasta {{max}} caracteres.',
      tooManyListItems: 'Podés cargar hasta {{max}} reglas por lista.',
    },
  },
  result: {
    copy: 'Copiar',
    copyAll: 'Copiar todo',
    pieceActions: 'Acciones de la pieza',
    export: 'Exportar',
    edit: 'Editar',
    save: 'Guardar',
    cancel: 'Cancelar',
    reddit: {
      threadContext: 'Hilo destino',
    },
    x: {
      variants: 'Variantes de post',
      thread: 'Hilo',
      variantNumber: 'Variante {{number}}',
      tweetNumber: 'Tweet {{current}}/{{total}}',
      repliesTitle: 'Tus replies para los primeros 30 minutos',
      repliesNote: 'Responder rápido multiplica el alcance.',
      linkReply: 'Reply con link',
    },
    regenerate: {
      action: 'Regenerar',
      title: 'Regenerar borrador',
      description:
        'Opcionalmente sumá feedback para guiar el nuevo borrador. La pieza vuelve a Borrador.',
      placeholder: 'ej. más corto, más concreto, menos vendedor…',
      cancel: 'Cancelar',
      confirm: 'Regenerar',
      regenerating: 'Regenerando…',
      regeneratingHint: 'Puede tardar hasta un minuto — el borrador se actualiza acá solo.',
    },
    publishedLocked: 'Esta pieza ya se publicó.',
    approve: {
      action: 'Aprobar',
    },
    unapprove: {
      action: 'Volver a borrador',
    },
    publish: {
      action: 'Marcar como publicado',
      title: 'Marcar como publicado',
      description:
        'Registrá dónde y cuándo se publicó esta pieza. Esto solo deja el registro: no se publica nada desde acá.',
      urlLabel: 'URL de la publicación (opcional)',
      urlPlaceholder: 'https://…',
      dateLabel: 'Fecha de publicación',
      cancel: 'Cancelar',
      confirm: 'Registrar publicación',
    },
    composer: {
      blockedNotApproved: 'Aprobá la pieza para publicarla. Podés seguir escribiendo y guardando.',
      blockedAlreadyPublished: 'Esta pieza ya está registrada como publicada.',
    },
    versions: {
      action: 'Historial',
      generationAction: 'Historial de generación',
      title: 'Historial de versiones',
      description:
        'Cada sobrescritura de esta pieza — regeneraciones, guardados manuales y restauraciones — de la más nueva a la más vieja.',
      empty: 'Todavía no hay versiones. Aparecen cuando la pieza se regenera o se edita.',
      version: 'v{{version}}',
      back: 'Volver a la lista',
      unit: 'Unidad {{position}}',
      trigger: {
        regenerate: 'Regeneración',
        manual_edit: 'Edición manual',
        restore: 'Restauración',
      },
      time: {
        justNow: 'Recién',
        minutesAgo: 'hace {{minutes}}m',
        hoursAgo: 'hace {{hours}}h',
        daysAgo: 'hace {{days}}d',
      },
      restore: {
        action: 'Restaurar esta versión',
        title: '¿Restaurar la v{{version}}?',
        body:
          'El texto actual se guarda primero como una versión nueva, así que no se pierde nada. La aprobación se limpia — el texto restaurado necesita su propio visto bueno.',
        confirm: 'Restaurar',
        cancel: 'Cancelar',
        blocked: 'Una pieza publicada no se puede restaurar.',
      },
      retry: 'Reintentar',
      toast: {
        restored: 'Versión restaurada',
      },
      errors: {
        loadFailed: 'No se pudieron cargar las versiones.',
        detailLoadFailed: 'No se pudo cargar esta versión.',
        restoreFailed: 'No se pudo restaurar la versión.',
      },
    },
    toast: {
      copied: 'Copiado al portapapeles',
      saved: 'Cambios guardados',
      approved: 'Pieza aprobada',
      unapproved: 'La pieza volvió a borrador',
      published: 'Publicación registrada',
    },
    errors: {
      generateFailed: 'Falló la generación. Probá de nuevo.',
      regenerateFailed: 'Falló la regeneración. Probá de nuevo.',
      saveFailed: 'No se pudieron guardar los cambios.',
      approveFailed: 'No se pudo aprobar la pieza.',
      unapproveFailed: 'No se pudo volver a borrador.',
      publishFailed: 'No se pudo registrar la publicación.',
    },
  },
  create: {
    backToList: 'Volver al contenido',
  },
  detail: {
    notFound: 'No se encontró esta pieza.',
  },
  list: {
    title: 'Motor de Contenidos',
    subtitle: 'Cada pieza nativa redactada por el motor, por canal.',
    newAction: 'Crear contenido',
    searchPlaceholder: 'Buscar…',
    retry: 'Reintentar',
    filters: {
      channel: 'Canal',
      allChannels: 'Todos los canales',
      state: 'Estado',
      allStates: 'Todos los estados',
      quality: 'Calidad',
      allQualities: 'Todas las calidades',
      source: 'Fuente',
      allSources: 'Todas las fuentes',
    },
    columns: {
      piece: 'Pieza',
      channel: 'Canal',
      format: 'Formato',
      source: 'Fuente',
      state: 'Estado',
      actions: 'Acciones',
    },
    empty: {
      title: 'Todavía no hay contenido',
      description: 'Creá tu primera pieza nativa para Reddit, X o LinkedIn.',
      cta: 'Crear contenido',
    },
    delete: {
      title: '¿Eliminar esta pieza?',
      description: 'No se puede deshacer.',
      cancel: 'Cancelar',
      confirm: 'Eliminar',
    },
    toast: {
      deleted: 'Pieza eliminada',
    },
    pagination: {
      previous: 'Anterior',
      next: 'Siguiente',
      pageOf: 'Página {{page}} de {{total}}',
    },
    errors: {
      loadFailed: 'No se pudo cargar el contenido.',
      deleteFailed: 'No se pudo eliminar la pieza.',
    },
  },
  copilot: {
    title: 'Refy',
    subtitle: 'Pedile hooks, ángulos o reescrituras — anclado en tu voz de marca.',
    writingWithVoice: 'con tu voz: {{voice}}',
    open: 'Refy',
    close: 'Cerrar',
    inputPlaceholder: 'Preguntale a Refy…',
    send: 'Enviar',
    thinking: 'Refy está escribiendo…',
    welcome:
      '¡Hola! Soy Refy. Contame tu idea para tu post de {{channel}} y lo armo — o pedime hooks, un ángulo más filoso, o que complete el formulario desde tus notas.',
    suggestionFor: 'Sugerencia para {{field}}',
    apply: 'Aplicar',
    applied: 'Aplicado en {{field}}',
    unknownField: 'Esta sugerencia no tiene un campo asociado — copiala a mano.',
    fieldFallback: 'el campo',
    fillFormTitle: '{{count}} campos para completar',
    fillFormApply: 'Clic para completar el form',
    fillApplied: '{{count}} campos completados',
    fields: {
      stance: 'Postura',
      realDatum: 'Dato',
      hookType: 'Tipo de hook',
      closingNextStep: 'Cierre',
      hookSeed: 'Hook',
      linkUrl: 'Link',
      voiceOwner: 'Voz',
      threadUrl: 'Hilo',
      evidence: 'Evidencia',
      subredditContext: 'Contexto del subreddit',
      subreddit: 'Subreddit',
      topic: 'Tema',
      differentiator: 'Diferenciador',
      title: 'Título',
    },
    quickPrompts: {
      fillForm: 'Completá el form',
      anotherHook: 'Dame otro hook',
      sharpen: 'Hacelo más filoso',
      improveClosing: 'Mejorá el cierre',
      moreConcrete: 'Hacelo más concreto',
    },
    errors: {
      generic: 'Refy no pudo responder. Probá de nuevo.',
    },
  },
} as const
